import React, { useState, useEffect } from 'react';
import { Table } from 'antd';
import { APIRequest } from '../apis/api';

const { Column } = Table;

const CallsTableUkri = () => {
  const [pagination, setPagination] = useState({ page: 1, max: 10 });

  // 🔑 endpoint fijo al backend
  const [state, setUrl] = APIRequest(
    `/app/calls?data=ukri&page=${pagination.page}&max=${pagination.max}`
  );

  useEffect(() => {
    setUrl(`/app/calls?data=ukri&page=${pagination.page}&max=${pagination.max}`);
  }, [setUrl, pagination]);

  const onPageChange = (paginate) => {
    setPagination({
      page: paginate.current,
      max: paginate.pageSize,
    });
  };

  if (state.isLoading) {
    return <Table loading />;
  }

  return (
    <Table
      dataSource={state.data?.data || []}
      rowKey={(record, idx) => record.url ?? idx}
      onChange={onPageChange}
      sticky
      scroll={{ y: 400, x: 800 }}
      pagination={{
        total: state.data?.total || 0,
        current: pagination.page,
        pageSize: pagination.max,
        size: 'small',
        hideOnSinglePage: true,
      }}
    >
      <Column
        title="Nombre"
        dataIndex="title"
        key="title"
        width="20%"
        render={(item, datum) => (
          <a href={datum.url} target="_blank" rel="noreferrer">
            {item}
          </a>
        )}
      />
      <Column title="Descripción" dataIndex="description" key="description" width="30%" />
      <Column title="Fecha de publicación" dataIndex="publication_date" key="publication_date" />
      <Column title="Tipo" dataIndex="type" key="type" />
      <Column title="Fecha de apertura" dataIndex="opening_date" key="opening_date" />
      <Column title="Fecha de cierre" dataIndex="closing_date" key="closing_date" />
      <Column title="Fondos totales" dataIndex="total_fund" key="total_fund" />
      <Column
        title="Financiadores"
        dataIndex="funders"
        key="funders"
        render={(item, datum) => (
          <a href={datum.funders_url} target="_blank" rel="noreferrer">
            {item}
          </a>
        )}
      />
      <Column
        title="Estado"
        dataIndex="status"
        key="status"
        render={(item) => (item === 'Open' ? 'Abierta' : item)}
      />
    </Table>
  );
};

export default CallsTableUkri;
